import { Component, output } from '@angular/core';
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';

@Component({
  selector: 'eiq-header-basic-details',
  templateUrl: './header-basic-details.component.html',
  styleUrls: ['./header-basic-details.component.scss']
})
export class HeaderBasicDetailsComponent {
  back = output<void>();
  faArrowLeft = faArrowLeft;
}
